import React from "react";

interface TrainPageSkeletonProps {
  width?: string | number;
  height?: string | number;
  style?: React.CSSProperties;
}


const TrainPageSkeleton: React.FC<TrainPageSkeletonProps> = ({ width, height, style }) => (
  <div
    style={{
      width,
      height,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#FAFAFB",
      borderRadius: 12,
      boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
      ...style,
    }}
  >
    <div
      className="shimmer-skeleton-card"
      style={{
        width: "90%",
        height: "80%",
        background: "#e0e0e0",
        borderRadius: 8,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        className="shimmer-effect"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "60%",
          background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)",
          transform: "translateX(-100%)",
          animation: "shimmer 1.5s infinite",
        }}
      />
    </div>
    <style>{`
      @keyframes shimmer {
        0% { transform: translateX(-100%); }
        100% { transform: translateX(100%); }
      }
    `}</style>
  </div>
);

export default TrainPageSkeleton;
